const STORAGE_KEY = "guestPortal.requests.v1";

const safeParse = (raw, fallback) => {
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

const loadAll = () => {
  if (typeof window === "undefined") return [];
  const parsed = safeParse(window.localStorage.getItem(STORAGE_KEY), []);
  return Array.isArray(parsed) ? parsed : [];
};

const saveAll = (items) => {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
};

const makeId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `req-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

class GuestRequestService {
  list({ companyId, tableId } = {}) {
    return loadAll().filter((item) => {
      if (companyId && item.companyId !== companyId) return false;
      if (tableId && item.tableId !== tableId) return false;
      return true;
    });
  }

  create(payload) {
    const item = {
      id: makeId(),
      status: "requested",
      createdAt: new Date().toISOString(),
      ...payload,
    };
    const all = loadAll();
    all.unshift(item);
    saveAll(all);
    return item;
  }

  addFoodOrder(payload) {
    return this.create({
      type: "food",
      title: payload.title || "Food order",
      status: "confirmed",
      ...payload,
    });
  }

  update(id, patch) {
    const all = loadAll();
    const next = all.map((item) =>
      item.id === id ? { ...item, ...patch, updatedAt: new Date().toISOString() } : item
    );
    saveAll(next);
    return next.find((item) => item.id === id) || null;
  }

  cancel(id) {
    return this.update(id, { status: "cancelled" });
  }

  upsertToggle({ companyId, tableId, type, title, details, locationLabel, active }) {
    const existing = this.list({ companyId, tableId }).find(
      (item) => item.type === type && item.status !== "cancelled"
    );
    if (!active) {
      if (existing) this.cancel(existing.id);
      return null;
    }
    if (existing) {
      return this.update(existing.id, { title, details, locationLabel });
    }
    return this.create({
      companyId,
      tableId,
      type,
      title,
      details,
      locationLabel,
    });
  }
}

const GuestRequestServices = new GuestRequestService();

export default GuestRequestServices;
